<template>
  <b-form-group
    :label-cols="cols"
    :content-cols="cols"
    :label-align="labelPositionProp"
    :label-for="name || ''"
    :label-class="`p-0 align-self-center m-0 ${isRight ? 'order-2' : ''}`"
    class="input-field-component"
    @click="openInfo"
  >
    <div
      v-if="hasLabel"
      class="d-flex align-items-center labelMargin"
      :class="isLeft && textRight ? 'justify-content-end' : ''"
    >
      <span :class="`text-${labelWeight} text-secondary field-label`">
        {{ label }}
      </span>
      <span
        class="input-field-label"
        @click="openInfo"
      >
        <GjIcon
          v-if="infoPositionLabel && info"
          class="info-assistant-toggle"
          size="25"
          name="Info"
        />
      </span>
      <b-badge
        v-if="comingSoon"
        pill
        variant="light-primary"
        class="mr-1 ml-auto"
      >
        Coming soon
      </b-badge>
    </div>
    <div
      class="d-flex flex-column"
      :class="{ 'order-1': isRight }"
    >
      <div class="d-flex align-items-center">
        <slot />
        <span
          class="info-assistant"
          @click="openInfo"
        >
          <GjIcon
            v-if="!infoPositionLabel && info"
            class="info-assistant-toggle"
            size="25"
            name="Info"
          />
        </span>
      </div>
      <template v-if="success || error !== undefined">
        <small
          v-if="!success"
          class="text-danger errorContainer"
        >{{
          error
        }}</small>
        <small
          v-else
          class="text-success errorContainer"
        >{{ success }}</small>
      </template>
    </div>
  </b-form-group>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

export default {
  name: 'InputField',
  props: {
    name: {
      type: String,
      default: null,
    },
    labelPosition: {
      type: String,
      default: 'left',
    },
    id: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    info: {
      type: Object,
      default: null,
    },
    infoPosition: {
      type: String,
      default: 'input',
    },
    error: {
      type: String,
      default: undefined,
    },
    labelWeight: {
      type: String,
      default: 'regular',
    },
    success: {
      type: String,
      default: '',
    },
    textRight: {
      type: Boolean,
      default: true,
    },
    comingSoon: {
      type: Boolean,
      default: false,
    },
    hasLabel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      inputFieldID: '',
    }
  },
  computed: {
    isVertical() {
      return this.labelPosition === 'left' || this.labelPosition === 'right'
    },
    isRight() {
      return this.labelPosition === 'right'
    },
    isLeft() {
      return this.labelPosition === 'left'
    },
    labelPositionProp() {
      return this.labelPosition === 'left' ? 'right' : 'left'
    },
    infoPositionLabel() {
      return this.infoPosition === 'label'
    },
    cols() {
      if (this.isLeft) {
        return true
      }
      if (this.isRight) {
        return 'auto'
      }
      return false
    },
  },
  watch: {
    error() {
      this.$emit('onErrorChanged', this.error ? this.inputFieldID : '')
    },
  },
  created() {
    this.inputFieldID = uuidv4()
  },
  methods: {
    openInfo() {
      this.$emit('openInfo', this.info)
    },
  },
}
</script>

<style lang="scss" scoped>
.input-field-component {
  margin-bottom: 9px;
}

.labelMargin {
  margin-bottom: 10px;
}
.errorContainer {
  margin-top: 2px;
  height: 17px;
  width: 100%;
}
.input-field-label {
  min-height: 25px;
}
</style>
